import { Children, isValidElement, ReactNode } from "react";
import { MenuLink } from "./MenuLink";
import { matchPath } from "react-router-dom";
import { StylesConfig } from "react-select";

export const getMenuLinkPath = (children: ReactNode): string => {
  let path = "";

  Children.forEach(children, (child) => {
    if (isValidElement(child) && child.type === MenuLink && child.props.path) {
      path = child.props.path; // Assign the path when found
    }
  });

  return path;
};

export const hasMenuActiveChild = (
  path: string,
  children: ReactNode,
): boolean => {
  const childrenArray: ReactNode[] = Children.toArray(children);

  for (const child of childrenArray) {
    if (isValidElement(child)) {
      if (child.type === MenuLink && child.props.path) {
        if (path === "/") {
          if (child.props.path === path) {
            return true;
          }
        } else {
          if (matchPath(child.props.path as string, path)) {
            return true;
          }
        }
      } else if (hasMenuActiveChild(path, child.props.children as ReactNode)) {
        return true;
      }
    }
  }

  return false;
};

export const customThemeStylesForReactSelect = (
  theme: string,
): StylesConfig => ({
  control: (provided, state) => ({
    ...provided,
    boxShadow: state.isFocused ? "0 0 0 0.25rem rgba(13,110,253,.25)" : "red",
    backgroundColor: "transparent",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: theme === "dark" ? "#ffffff" : "#000000",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? theme === "dark"
        ? "rgba(17, 18, 23, 1)"
        : "#f9f9f9"
      : state.isFocused
        ? theme === "dark"
          ? "rgba(17, 18, 23, 1)"
          : "#f9f9f9"
        : theme === "dark"
          ? "#000"
          : "#fff",
    color: state.isSelected ? "#006AE6" : "",
    "&:active": {
      backgroundColor: theme === "dark" ? "rgba(17, 18, 23, 1)" : "#f9f9f9",
      color: "#006AE6",
    },
    borderColor: state.isFocused ? "#86b7fe" : "#dee2e6",
  }),
  menuList: (provided) => ({
    ...provided,
    backgroundColor: theme === "dark" ? "#000000" : "#fff",
    borderColor: theme === "dark" ? "#000000" : "#fff",
    maxHeight: "150px", // Set the max height for the options container
    overflowY: "auto",
  }),
});

export const ToFormData = (data: Record<string, unknown>): FormData => {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      if (value instanceof Blob) {
        formData.append(key, value);
      } else if (typeof value === "object") {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, String(value));
      }
    }
  });
  return formData;
};
